import { Typography, Box, Stack } from "@mui/material";
import { ProductTableActionsPopover } from "./product-table-actions-popover";
import { formatLabel } from "@/utils/format-label";

export const getProductsColumns = (onEditClick) => [
  {
    accessorKey: "id",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Product ID</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.original.id ?? "—"}</Typography>
    ),
  },

  {
    accessorKey: "name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Product Name</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.name ?? "—"}
      </Typography>
    ),
  },

  {
    accessorKey: "description",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Description</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.description ?? "—"}
      </Typography>
    ),
  },

  {
    accessorKey: "percentage",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Percentage</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.percentage ?? 0}%
      </Typography>
    ),
  },

  {
    accessorKey: "status",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Approval</div>,
    cell: ({ row }) => {
      const status = row.original.status;

      const colorMap = {
        APPROVED: { bg: "#f0fdf4", color: "#15803d", dot: "#16a34a" },
        PENDING: { bg: "#fffbeb", color: "#b45309", dot: "#f59e0b" },
        REJECTED: { bg: "#fef2f2", color: "#dc2626", dot: "#dc2626" },
      };

      const style = colorMap[status] || {
        bg: "#f3f4f6",
        color: "#374151",
        dot: "#6b7280",
      };

      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: style.bg,
            color: style.color,
            fontSize: "0.8rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: style.dot,
            }}
          />
          {formatLabel(status ?? "UNKNOWN")}
        </Box>
      );
    },
  },

  {
    accessorKey: "isActive",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const isActive = row.original.isActive;

      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: isActive ? "#f0fdf4" : "#fef2f2",
            color: isActive ? "#15803d" : "#dc2626",
            fontSize: "0.8rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: isActive ? "#16a34a" : "#dc2626",
            }}
          />
          {isActive ? "Active" : "Inactive"}
        </Box>
      );
    },
  },

  {
    accessorKey: "createdBy",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Created By</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.createdBy ?? "—"}
      </Typography>
    ),
  },

  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Created At</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.createdAt
          ? new Date(row.original.createdAt).toLocaleString()
          : "—"}
      </Typography>
    ),
  },

  {
    id: "actions",
    header: () => <div>Action</div>,
    cell: ({ row }) => (
      <Stack direction="row" justifyContent="center">
        <ProductTableActionsPopover
          product={row.original}
          onEditClick={onEditClick}
        />
      </Stack>
    ),
  },
];
